import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectSessionAdvisor } from '@client/model/selectors';

/**
 * Generic redirect component that captures a sub-path and redirects to the
 * advisor's dashboard with that path appended.
 *
 * Route: /advisors/redirect/*
 *
 * Examples:
 * - /advisors/redirect/team?view=invitations → /advisors/{advisorId}/team?view=invitations
 * - /advisors/redirect/settings → /advisors/{advisorId}/settings
 * - /advisors/redirect/clients → /advisors/{advisorId}/clients
 */
export function AdvisorRedirect() {
  const navigate = useNavigate();
  const { '*': subPath } = useParams();
  const [searchParams] = useSearchParams();
  const advisor = useSelector(selectSessionAdvisor);

  useEffect(() => {
    if (advisor?.advisorId) {
      const queryString = searchParams.toString();
      const pathSuffix = subPath ? `/${subPath}` : '';
      const fullPath = `/advisors/${advisor.advisorId}${pathSuffix}${queryString ? `?${queryString}` : ''}`;

      navigate(fullPath, { replace: true });
    }
  }, [advisor?.advisorId, subPath, searchParams, navigate]);

  return null;
}

